import { AUTH_ROUTES, AuthRoutes } from '@cibo/profile'
import { ROUTE } from '@cibo/ui'
import { Navigate, Route } from 'react-router-dom'
import { PolicyPage } from './PolicyPage/PolicyPage'

export const LoggedOutRoutes = () => (
  <AuthRoutes>
    <Route path="*" element={<Navigate replace to={AUTH_ROUTES.LOGIN} />} />
    <Route path={ROUTE.POLICY} element={<PolicyPage />} />
  </AuthRoutes>
)

export default LoggedOutRoutes
